import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { Title } from '@/components/ui/title';

interface TransferSuccessComponentProps {
	houseAddress: string;
}

/**
 * Success component displayed after property ownership transfer is completed
 * Shows confirmation message and provides navigation back to login
 */
const TransferSuccessComponent: React.FC<TransferSuccessComponentProps> = ({ houseAddress }) => {
	return (
		<Box maxW="550px" mx="auto" p={{ base: 4, md: 16 }} pt={{ base: 8, md: 16 }} pb={{ base: 8, md: 16 }}>
			<VStack gap={8} align="center">
				{/* Bundle Logo */}
				<Title level="celebration" textAlign="center">
					Transfer successful
				</Title>

				{/* Success Icon */}
				<Box>
					<svg width="64" height="64" viewBox="0 0 64 64" fill="none">
						<path
							d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
							fill="#2C4454"
						/>
						<path
							d="M29.8352 41.0707L21.1645 32.5061L23.8731 29.7618L29.9227 35.7355L43.7254 22.9594L46.3442 25.7879L29.8352 41.0707Z"
							fill="#FFF700"
						/>
					</svg>
				</Box>

				<Text textStyle="body.strong" textAlign="center">
					Ownership of {houseAddress} has been handed on
				</Text>
			</VStack>
		</Box>
	);
};

export default TransferSuccessComponent;
